import { useEffect, useRef } from 'react'

import { debounce } from 'utils/helpers'

import useURLState from './useUrlState'

export { useURLState }

export const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export const useMount = (effectToRunOnce) => {
  // NOTE: This will only call a function once after the component is mounted
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effectToRunOnce, [])
}

export const useDidUpdate = (effect, deps) => {
  const mount = useRef()

  useEffect(() => {
    if (mount.current) return effect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  useMount(() => {
    mount.current = true
    // IC-52036: StrictMode re-runs effects after a simulated unmount; without the reset the re-run counts as an update
    return () => {
      mount.current = false
    }
  })
}

export const useDebounce = (callback, delay = 500) => {
  const reDebounceCallback = useRef(debounce(callback, delay)).current

  return reDebounceCallback
}
